import { Outlet } from "react-router-dom";
import { AppLayout } from "layout/AppLayout";

export const AppContent: React.FC = () => {
  return (
    <div>
      <AppLayout />
      <Outlet />
    </div>
  );
};
